import { keepCountOnForm } from '../property/search-form';

function clearSearchForm( form, triggerChange ) {
    form.querySelectorAll( 'input,select' ).forEach( function( el ) {
        if ( [ 'offer', 'source' ].includes( el.name ) ) {
            return;
        }

        if ( el.type === 'checkbox' ) {
            el.checked = false;
        } else if ( el.value && el.value.length > 0 ) {
            el.value = '';
        }

        if ( triggerChange ) {
            el.dispatchEvent( new Event( 'change' ) );
        }
    } );
}

function copySearchFormToModal( form, modalForm ) {
    clearSearchForm( modalForm, false );

    var elementsToSkip = [ 'source' ];

    form.querySelectorAll( '[name]' ).forEach( function( inputElement ) {
        if ( elementsToSkip.includes( inputElement.name ) ) {
            return;
        }

        // handler unmatched case (single 'property-type' sent)
        if ( inputElement.name === 'property-type' ) {
            modalForm.querySelector( '[data-groups]' ).value = 'other';
            modalForm.querySelectorAll( '[data-group]' ).forEach( function( groupElement ) {
                if ( groupElement.dataset.group !== 'other' ) {
                    groupElement.classList.add( 'ts-checktags--hidden' );
                } else {
                    groupElement.classList.remove( 'ts-checktags--hidden' );
                    groupElement.querySelectorAll( 'input[type=checkbox]' ).forEach( function( el ) {
                        el.checked = true;
                    } );
                }
            } );
            return;
        }

        if ( inputElement.name === 'types' ) {
            var type = inputElement.value;
            if ( type === '' ) {
                return;
            }
            var cbx = modalForm.querySelector( 'input[name=types][value=' + type + ']' );
            if ( !cbx ) {
                return;
            }
            cbx.checked = true;
            var group = cbx.closest( '[data-group]' );
            group.classList.remove( 'ts-checktags--hidden' );
            modalForm.querySelector( '[data-groups]' ).value = group.dataset.group;
            return;
        }

        if ( inputElement.name === 'tags' ) {
            var tagCheckbox = modalForm.querySelector( '[name=' + inputElement.name + '][value=' + inputElement.value + ']' );
            if ( tagCheckbox ) {
                tagCheckbox.checked = true;
            }
            return;
        }

        var dest = modalForm.querySelector( '[name=' + inputElement.name + ']' );
        if ( !dest ) {
            return;
        }

        if ( dest.type === 'checkbox' ) {
            dest.checked = true;
        } else {
            if ( inputElement.name === 'locationFreeText' ) {
                var freeTextReset = modalForm.querySelector( '.awesomplete .reset-field' );

                if ( freeTextReset ) {
                    if ( inputElement.value.length > 0 ) {
                        freeTextReset.style.display = '';
                    } else {
                        freeTextReset.style.display = 'none';
                    }
                }

                var radiusContainer = modalForm.querySelector( '.searchpopup__location-radius' );
                if ( radiusContainer ) {
                    if ( inputElement.dataset.tsGeo === 'true' ) {
                        radiusContainer.classList.remove( 'd-none' );
                    } else {
                        radiusContainer.classList.add( 'd-none' );
                    }
                }
            }

            if ( dest.value === inputElement.value ) {
                return;
            }

            dest.value = inputElement.value;

            if ( inputElement.name === 'locationId' ) {
                dest.dataset.isIsland =  inputElement.dataset.isIsland;
                dest.dataset.isGeocoded =  inputElement.dataset.isGeocoded;
                dest.dataset.longitude =  inputElement.dataset.longitude;
                dest.dataset.latitude =  inputElement.dataset.latitude;
                dest.dataset.id = inputElement.dataset.id;
                dest.dataset.type = inputElement.dataset.type;
                dest.dataset.location = inputElement.dataset.location || '';
            }

            if ( dest.nodeName === 'SELECT' && !inputElement.value ) {
                dest.classList.remove( 'has-value' );
            }

            if ( dest.nodeName === 'SELECT' && inputElement.value ) {
                dest.classList.add( 'has-value' );
            }
        }

        dest.dispatchEvent( new Event( 'change', { bubbles: true } ) );
    } );
}

function openGenericSearchPopup() {
    const popupsearch = document.getElementById( 'search-filter-popup' );

    document.documentElement.style.setProperty( '--vh', `${window.innerHeight * 0.01}px` );

    document.documentElement.classList.add( 'popup-open-search' );

    document.body.classList.add( 'popup-open' );

    popupsearch.classList.add( 'pagepopup__wrapper--open' );

    const form = document.getElementById( 'search-form-base' );
    const modalForm = document.getElementById( 'search-form-popup' );

    if ( form && modalForm ) {
        copySearchFormToModal( form, modalForm );
    }

    popupsearch.querySelectorAll( '[data-action="close"]' ).forEach( ( btn ) => {
        btn.addEventListener( 'click', function() {
            document.body.classList.remove( 'popup-open' );

            document.documentElement.classList.remove( 'popup-open-search' );

            popupsearch.classList.remove( 'pagepopup__wrapper--open' );

            window.requestAnimationFrame( () => {
                document.documentElement.scrollTop = window.router.currentState.scrollPosition;
            } );
        } );
    } );
}

export function prepareSearch( modalForm ) {
    const btnReset = modalForm.querySelector( '.btn-reset' );

    if ( btnReset ) {
        btnReset.addEventListener( 'click', function() {
            clearSearchForm( modalForm, true );
        } );
    }

    const btnCancel = modalForm.querySelector( '.btn-cancel' );

    if ( btnCancel ) {
        btnCancel.addEventListener( 'click', function() {
            modalForm.querySelector( '[data-action="close"]' ).click();
        } );
    }
}

function openSearchFilters() {
    const modalForm = document.getElementById( 'search-form-popup' );
    prepareSearch( modalForm );

    openGenericSearchPopup();

    if ( modalForm && modalForm.dataset.keepCount && modalForm.dataset.keepCount === 'true' ) {
        keepCountOnForm( modalForm, true );
    }
}

export default openSearchFilters;
